import loadable from "@loadable/component";
import { FC } from "react";
import { useParams } from "react-router-dom";
import { ICreateCategoryData } from "../../components/Category/CreateCategory";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/Endpoint";
import useFormdataPatchHook from "../../customHooks/useFormdataPatchHook";
import useGetHook from "../../customHooks/useGetHook";
import { queryClient } from "../../root.component";
import { ICategorySchema } from "../../utils/validationSchema";

const EditCategoryComponent = loadable(
  () =>
    import("../../components/Category/EditCategory") as unknown as Promise<FC>
);

export const EditCategory = () => {
  const { id } = useParams();

  const { mutateAsync, isLoading } = useFormdataPatchHook({
    queryKey: [`update-blog-category-${id}`],
    navigateURL: "/blog/category",
  });

  const { data, isLoading: isGettingData } = useGetHook({
    queryKey: [`blog-category-${id}`],
    url: `${APIS.BLOG_CATEGORY}${id}/`,
    params: {},
  });

  const handleEdit = async (data: ICategorySchema, setError: any) => {
    const file = data.preview_image as File;
    delete data.preview_image;
    const url = `${APIS.BLOG_CATEGORY}${id}/`;
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (typeof data[key]) {
        case "string":
        case "number":
        case "boolean":
          formData.append(key, data[key]);
          break;
        default:
          formData.append(key, JSON.stringify(data[key]));
      }
    });
    if (file instanceof File) formData.append("preview_image", file);
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return isGettingData ? (
    <Spinner />
  ) : (
    <>
      <EditCategoryComponent
        /*@ts-ignore */
        categoryId={id}
        handleEdit={handleEdit}
        isLoading={isLoading}
        data={data}
      />
    </>
  );
};
